



















import {Component, Vue} from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import GraphButton from '@/components/GraphButton.vue';
import Chart from './mychart.js'
import UserData from "../components/UserData";

@Component({
    components: {
        UserData,
        HelloWorld, Chart, GraphButton,
    },
    computed: {
        ready() {
            const graph_data = this.$store.state.graph_data.graph_data;
            const user_data = this.$store.state.user_data.user_data;
            return Object.keys(graph_data).length !== 0 && Object.keys(user_data).length !== 0;
        },
        datacollection() {
            const graph_data = this.$store.state.graph_data.graph_data;
            const selected_graph = this.$store.state.graph_button.selected;
            if (Object.keys(graph_data).length !== 0) {
                Chart.deactivateAnimation();
                return {'datasets': [graph_data[selected_graph]]};
            }
            else {
                return {'datasets': [{}]}
            }
        }
    },
})
export default class Home extends Vue {
}
